export default __webpack_public_path__ + "static/media/photo--sm--kara13.8beab327.jpg";